export default __webpack_public_path__ + "static/media/Stop.ec73b6a3.svg";